import moment from 'moment'

import { TaskStatusWidget } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components'
import { TasksQueueOptions } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components'
import { ImageComponent } from '@apps-common/components/common'
import { UnitStatusWidget } from '@apps-common/components/unit'
import { commonIcons } from '@apps-common/config/icons'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

export const buildTableKeys = () => [
  {
    title: '',
    key: 'productImageUrl',
    static: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: any) => (
      <ImageComponent
        src={props.productImageUrl}
        alt='Product image'
        containerClasses='w-[36px] h-[36px] bg-surface-2 rounded-full flex items-center justify-center'
        imageClasses='w-[28px] h-[28px]'
      />
    )
  },
  {
    title: 'Product',
    key: 'productName',
    changeable: true,
    noCopy: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell'
  },
  {
    title: 'Status',
    key: 'status',
    changeable: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskQueueModel) => <TaskStatusWidget status={props.status} />
  },
  {
    title: 'Message',
    key: 'message',
    changeable: true,
    noCopy: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell'
  },
  {
    title: 'Account',
    key: 'accountNo',
    changeable: true,
    noCopy: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell'
  },
  {
    title: 'Mobile',
    key: 'mobileNo',
    changeable: true,
    noCopy: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell'
  },

  // optional - start

  {
    title: 'Device Status',
    key: 'unitStatus',
    optional: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: IUnitTaskQueueModel) => <UnitStatusWidget status={props.unitStatus} />
  },
  {
    title: 'Site',
    key: 'siteName',
    optional: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: IUnitTaskQueueModel) => <div>{props.siteName || <commonIcons.dash />}</div>
  },
  {
    title: 'Serial',
    key: 'serialNo',
    optional: true,
    thClasses: '',
    tdClasses: ''
  },
  {
    title: 'IMEI',
    key: 'imei',
    optional: true,
    thClasses: '',
    tdClasses: ''
  },
  {
    title: 'Mobile',
    key: 'mobileNo',
    optional: true,
    thClasses: '',
    tdClasses: ''
  },
  {
    title: 'IP',
    key: 'ipAddress',
    optional: true,
    thClasses: '',
    tdClasses: ''
  },
  {
    title: 'SIM',
    key: 'simNo',
    optional: true,
    thClasses: '',
    tdClasses: ''
  },
  {
    title: 'UpdatedBy',
    key: 'updatedBy',
    optional: true,
    thClasses: '',
    tdClasses: ''
  },
  {
    title: 'UpdatedAt',
    key: 'updatedAt',
    optional: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: IUnitTaskQueueModel) => (
      <div>{props.updatedAt ? moment(props.updatedAt).format('DD/MM/YY HH:mm') : <commonIcons.dash />}</div>
    )
  },
  {
    title: 'CompletedAt',
    key: 'completedAt',
    optional: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: IUnitTaskQueueModel) => (
      <div>{props.completedAt ? moment(props.completedAt).format('DD/MM/YY HH:mm') : <commonIcons.dash />}</div>
    )
  },
  {
    title: 'Server',
    key: 'serverKey',
    optional: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: IUnitTaskQueueModel) => <div>{props.serverKey ? props.serverKey : <commonIcons.dash />}</div>
  },

  // optional - end
  {
    title: 'Actions',
    key: 'actions',
    static: true,
    thClasses: 'text-right ',
    tdClasses: '',
    Component: (props: IUnitTaskQueueModel) => <TasksQueueOptions model={props} />
  }
]
